import ExpandParagraph from './ExpandParagraph';

export default ExpandParagraph;